import React from 'react';

export default function LeaderBoardRow(props){
    return (<div className="row px-3">
    <div className="col p-0 text-start">{props.Name}</div>
    <div className="col p-0"></div>
    <div className="col p-0"></div>
    <div className="col p-0 text-end">{props.Score}</div>
  </div>);
  }